export default __webpack_public_path__ + "static/media/pamflet.e863a61d.jpg";